var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "photo-gallery flex flex-wrap",
        attrs: { itemscope: "", itemtype: "http://schema.org/ImageGallery" }
      },
      _vm._l(_vm.items, function(item, index) {
        return _c(
          "figure",
          {
            key: index,
            staticClass: "w-full sm:w-1/2 md:w-1/3 lg:w-1/4 sm:p-1",
            attrs: {
              itemprop: "associatedMedia",
              itemscope: "",
              itemtype: "http://schema.org/ImageObject",
              src: item.src
            }
          },
          [
            _c(
              "a",
              {
                staticClass: "relative block",
                attrs: {
                  href: item.src,
                  itemprop: "contentUrl",
                  "data-size": "" + item.w + "x" + item.h,
                  title: item.caption
                }
              },
              [
                _c("img", {
                  staticClass: "block",
                  attrs: {
                    src: item.thumbnail,
                    itemprop: "thumbnail",
                    alt: item.caption
                  }
                }),
                _vm._v(" "),
                item.caption
                  ? _c(
                      "figcaption",
                      {
                        staticClass:
                          "script-caption-pink absolute right-0 bottom-0 p-4 text-lg"
                      },
                      [_c("em", [_vm._v(_vm._s(item.caption))])]
                    )
                  : _vm._e()
              ]
            )
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "pswp",
        attrs: { tabindex: "-1", role: "dialog", "aria-hidden": "true" }
      },
      [
        _c("div", { staticClass: "pswp__bg" }),
        _vm._v(" "),
        _c("div", { staticClass: "pswp__scroll-wrap" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "pswp__ui pswp__ui--hidden" }, [
            _c("div", { staticClass: "pswp__top-bar" }, [
              _c("div", { staticClass: "pswp__counter" }),
              _vm._v(" "),
              _c("button", {
                staticClass: "pswp__button pswp__button--close",
                attrs: { title: "Close (Esc)" }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "rotation-wrapper" }, [
                _vm.options.rotationOn
                  ? _c(
                      "i",
                      {
                        staticClass: "material-icons",
                        on: {
                          click: function($event) {
                            return _vm.rotate(-90)
                          }
                        }
                      },
                      [_vm._v("rotate_left")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.options.rotationOn
                  ? _c(
                      "i",
                      {
                        staticClass: "material-icons",
                        on: {
                          click: function($event) {
                            return _vm.rotate(90)
                          }
                        }
                      },
                      [_vm._v("rotate_right")]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("button", {
                staticClass: "pswp__button pswp__button--share",
                attrs: { title: "Share" }
              }),
              _vm._v(" "),
              _c("button", {
                staticClass: "pswp__button pswp__button--fs",
                attrs: { title: "Toggle fullscreen" }
              }),
              _vm._v(" "),
              _c("button", {
                staticClass: "pswp__button pswp__button--zoom",
                attrs: { title: "Zoom in/out" }
              }),
              _vm._v(" "),
              _vm._m(1)
            ]),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c("button", {
              staticClass: "pswp__button pswp__button--arrow--left",
              attrs: { title: "Previous (arrow left)" },
              on: { click: _vm.resetAngle }
            }),
            _vm._v(" "),
            _c("button", {
              staticClass: "pswp__button pswp__button--arrow--right",
              attrs: { title: "Next (arrow right)" },
              on: { click: _vm.resetAngle }
            }),
            _vm._v(" "),
            _vm._m(3)
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pswp__container" }, [
      _c("div", { staticClass: "pswp__item" }),
      _vm._v(" "),
      _c("div", { staticClass: "pswp__item" }),
      _vm._v(" "),
      _c("div", { staticClass: "pswp__item" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pswp__preloader" }, [
      _c("div", { staticClass: "pswp__preloader__icn" }, [
        _c("div", { staticClass: "pswp__preloader__cut" }, [
          _c("div", { staticClass: "pswp__preloader__donut" })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "pswp__share-modal pswp__share-modal--hidden pswp__single-tap"
      },
      [_c("div", { staticClass: "pswp__share-tooltip" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pswp__caption" }, [
      _c("div", { staticClass: "pswp__caption__center" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }